import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Panel, Alert } from 'react-bootstrap';
import { FormWizard, FieldList } from '../../';
import { connect } from 'react-redux';
import * as Actions from 'actions';
import * as Permissions from 'permissions';

const copy = o => JSON.parse(JSON.stringify(o));

class PipelineBuilderSettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      adding_stage : false,
      pipeline : {
        account : undefined,
        stages : []
      },
      actions : [
        { label : 'Create Damage Incident', action : Actions.startCreateIncident() }
      ],
      new_stage_name : '',
      selected_stage : 0,
    }

    this.handleCreateStage = this.handleCreateStage.bind(this);
    this.handleDeleteStage = this.handleDeleteStage.bind(this);
    this.handleStageSelect = this.handleStageSelect.bind(this);
    this.handleSelectField = this.handleSelectField.bind(this);
    this.handleRemoveField = this.handleRemoveField.bind(this);
    this.handleSelectAction = this.handleSelectAction.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.moveStepUp = this.moveStepUp.bind(this);
    this.moveStepDown = this.moveStepDown.bind(this);
    this.moveStageRight = this.moveStageRight.bind(this);
    this.moveStageLeft = this.moveStageLeft.bind(this);
  }
  componentWillMount() {
    this.props.fetchFields('Client');
    this.props.fetchFields('Job');
    this.props.fetchPipeline();
  }
  componentWillUpdate(nextProps, nextState) {
    if(!nextProps.pipeline.pipeline) {
      return;
    }
    if(!this.state.pipeline._id || nextProps.pipeline.pipeline._id != this.state.pipeline._id) {
      this.setState({ pipeline : copy(nextProps.pipeline.pipeline) });
    }
  }
  handleRemoveField(field_id) {
    let pipeline = copy(this.state.pipeline);
    pipeline.stages[this.state.selected_stage].steps = pipeline.stages[this.state.selected_stage].steps.filter(({field}) => field != field_id);
    this.setState({pipeline});
  }
  handleSelectField(field) {
    let pipeline = copy(this.state.pipeline);
    pipeline.stages[this.state.selected_stage].steps.push({
      type : 'field',
      field : field._id,
    });
    this.setState({pipeline})
  }
  handleSelectAction({action, label}) {
    let pipeline = copy(this.state.pipeline);
    pipeline.stages[this.state.selected_stage].steps.push({
      type : 'action',
      action,
      label,
    });
    this.setState({pipeline})
  }
  handleCreateStage() {
    let pipeline = copy(this.state.pipeline);
    pipeline.stages.push({
      name : this.state.new_stage_name,
      steps : []
    });
    this.setState({pipeline, adding_stage : false, new_stage_name : ''});
  }
  handleDeleteStage() {
    let pipeline = copy(this.state.pipeline);
    pipeline.stages = pipeline.stages.filter((item , index) => index != this.state.selected_stage);
    this.setState({pipeline});
  }
  handleStageSelect(stage) {
    if(stage == this.state.pipeline.stages.length) {
      this.setState({adding_stage : true});
    }
    else {
      this.setState({selected_stage : stage})
    }
  }
  handleSave(event) {
    this.props.savePipeline(this.state.pipeline);
  }
  moveStageLeft(stage_index) {
    let pipeline = copy(this.state.pipeline);
    let {stages} = pipeline;
    let new_stages = [
      ...stages.slice(0, stage_index - 1),
      stages[stage_index],
      ...stages.slice(stage_index - 1, stage_index),
      ...stages.slice(stage_index + 1, stages.length)];
    pipeline.stages = new_stages;
    this.setState({pipeline, selected_stage : stage_index - 1});
  }
  moveStageRight(stage_index) {
    let pipeline = copy(this.state.pipeline);
    let {stages} = pipeline;
    let new_stages = [
      ...stages.slice(0, stage_index),
      ...stages.slice(stage_index + 1, stage_index + 2),
      stages[stage_index],
      ...stages.slice(stage_index + 2, stages.length)];
    pipeline.stages = new_stages;
    this.setState({pipeline, selected_stage : stage_index + 1});
  }
  moveStepUp(stage_index, step_index) {
    let pipeline = copy(this.state.pipeline);
    let {steps} = pipeline.stages[stage_index];
    let new_steps = [
      ...steps.slice(0,step_index - 1),
      steps[step_index],
      ...steps.slice(step_index - 1, step_index),
      ...steps.slice(step_index + 1, steps.length)
    ];
    pipeline.stages[stage_index].steps = new_steps;
    this.setState({pipeline});
  }
  moveStepDown(stage_index, step_index) {
    let pipeline = copy(this.state.pipeline);
    let {steps} = pipeline.stages[stage_index];
    let new_steps = [
      ...steps.slice(0,step_index),
      ...steps.slice(step_index + 1, step_index + 2),
      steps[step_index],
      ...steps.slice(step_index + 2, steps.length)
    ];
    pipeline.stages[stage_index].steps = new_steps;
    this.setState({pipeline});
  }
  render() {
    if(!this.props.hasPermission(Permissions.UPDATE_PIPELINE_SETTINGS)) {
      return <Alert bsStyle='warning'>
        <h4>Sorry! Insufficient Permissions.</h4>
        <p>You must have gotten here in error, because you do not have permission to change these settings.</p>
        <p>Contact your administrator if this makes no sense.</p>
      </Alert>
    }

    const { pipeline, actions } = this.state;
    const { fields } = this.props;
    if(this.props.pipeline.fetching) {
      return <div>
        <p className='text-center'><i className='fa fa-spinner fa-spin fa-2x'></i></p>
        <p className='text-center'>Downloading Pipeline</p>
      </div>
    }
    if(this.props.pipeline.saving) {
      return <div>
        <p className='text-center'><i className='fa fa-spinner fa-spin fa-2x'></i></p>
        <p className='text-center'>Saving Pipeline</p>
      </div>
    }
    let field = id => (([...(fields.Client || []), ...(fields.Job || [])] || []).find(({_id}) => _id == id));
    return (
      <div>
        <Row>
          <Col xs={12} md={3}>
            <h3 className='mt-none'>Menu</h3>
            <p>Select Items to Add to the Pipeline</p>
            <div className='panel'>
              <div className='panel-body'>
                <h4>Fields</h4>
                <h5>Client</h5>
                <ul className='list-unstyled list-inline'>
                  {(fields.Client || []).map((field, index) => <li key={index} className='mb-xs'><a onClick={e => this.handleSelectField(field)} className='btn btn-sm btn-primary'><i className='fa fa-puzzle-piece'></i> {field.label}</a></li>)}
                </ul>
                <h5>Opportunity</h5>
                <ul className='list-unstyled list-inline'>
                  {(fields.Job || []).map((field, index) => <li key={index} className='mb-xs'><a onClick={e => this.handleSelectField(field)} className='btn btn-sm btn-primary'><i className='fa fa-puzzle-piece'></i> {field.label}</a></li>)}
                </ul>
                <hr />
                <h4>Actions</h4>
                <ul className='list-unstyled list-inline'>
                  {actions.map((action, index) => <li key={index}><a onClick={e => this.handleSelectAction(action)} className='btn btn-sm btn-primary'><i className='fa fa-plus-square-o'></i> {action.label}</a></li>)}
                </ul>
              </div>
            </div>
          </Col>
          <Col xs={12} md={9}>
            {this.state.adding_stage ? (
              <div className='animated fadeInDown'>
                <h3 className='mt-none'>Add Stage</h3>
                <p>Enter the name of the new stage you are creating.</p>
                <input className='form-control' onChange={e => this.setState({new_stage_name : e.target.value})} value={this.state.new_stage_name} placeholder='Enter Stage Name' />
                <Row className='mt-sm'>
                  <Col xs={6} md={4} mdOffset={4}>
                    <div onClick={e => this.setState({adding_stage : false})} className='btn btn-block btn-default'>Cancel</div>
                  </Col>
                  <Col xs={6} md={4}>
                    <div onClick={this.handleCreateStage} className='btn btn-block btn-success'><i className='fa fa-plus'></i> Save Stage</div>
                  </Col>
                </Row>
              </div>
            ) : ''}

            <Row>
              <Col md={4} xs={4}>
                <h3 className='mt-none'>Pipeline</h3>
                <p>The way the pipeline will be displayed.</p>
              </Col>
              <Col md={8} xs={8}>
                <div
                  onClick={this.handleSave}
                  className='btn btn-success pull-right'
                  style={{ position : 'relative', top : '10px' }}
                  >
                  <i className='fa fa-save'></i> Save Pipeline
                </div>
              </Col>
            </Row>
            <FormWizard.Wizard tab={this.state.selected_stage} onTab={this.handleStageSelect} shouldTab={f => false}>
              {pipeline.stages.map( (stage, stage_index) =>
                <FormWizard.Tab title={stage.name} key={stage_index}>
                  <div>
                    <div className='clearfix'>
                      <div className='btn-group pull-right mt-none'>
                        {stage_index != 0 ? <div onClick={e => this.moveStageLeft(stage_index)} className='btn btn-default'><i className='fa fa-arrow-left'></i></div> : ''}
                        {pipeline.stages.length != 1 ? <div className='btn btn-default'>Move Stage {stage_index + 1}</div> : ''}
                        {stage_index != pipeline.stages.length - 1 ? <div onClick={e => this.moveStageRight(stage_index)} className='btn btn-default'><i className='fa fa-arrow-right'></i></div> : ''}
                      </div>
                      <h3 className='text-muted pull-left'>{stage.name} Steps</h3>
                    </div>

                    <hr className='dotted mb-sm mt-none'/>
                  {stage.steps && stage.steps.length == 0 ? <p className='text-center'>No steps created yet. Select one from the menu to get started.</p> : ''}
                  {stage.steps.map((step, step_index) =>
                    <div
                      key={step_index}
                      className='mb-sm clearfix animated fadeInDown'
                      >
                      <span className='badge bg-primary mr-sm'>Step {step_index + 1}</span>
                      <div className='btn-group pull-right'>
                      {step_index != 0 ? (
                        <span onClick={e => this.moveStepUp(stage_index, step_index)} className='animated fadeInTop btn btn-default'><i className='fa fa-arrow-up'></i></span>
                      ) : ''}
                      {step_index != stage.steps.length - 1 ? (
                        <span onClick={e => this.moveStepDown(stage_index, step_index)} className='animated fadeInBottom btn btn-default'><i className='fa fa-arrow-down'></i></span>
                      ) : ''}
                        <span onClick={e => this.handleRemoveField(step.field)} className='animated fadeInRight btn btn-danger'><i className='fa fa-trash'></i></span>
                      </div>
                      {step.type == 'action' ? `${step.label}` : step.type == 'field' ? `${(field(step.field) || {}).placeholder}` : ''}
                    </div>
                  )}
                    <Row className='mt-sm'>
                      <Col xs={12} sm={6} md={4}>
                        {this.state.pipeline.stages.length > 0 ? (
                          <div onClick={this.handleDeleteStage} className='btn btn-block btn-danger'><i className='fa fa-trash'></i> Delete Stage</div>
                        ) : ''}
                      </Col>
                    </Row>
                  </div>
                </FormWizard.Tab>
              )}
              <FormWizard.Tab badge='+' title='Add Stage'><p className='text-center'>Click '+ Add Stage' to begin.</p></FormWizard.Tab>
            </FormWizard.Wizard>
          </Col>
        </Row>
      </div>
    )
  }
}

const mapStateToProps = ({fields, pipeline}) => ({fields, pipeline});

export default connect(mapStateToProps, Actions)(PipelineBuilderSettings);



// WEBPACK FOOTER //
// ./src/browser/components/clients/settings/pipeline-builder-settings.js